import { get, set, remove, update, child, ref, getDatabase, push, increment } from "firebase/database";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth,createUserWithEmailAndPassword,signInWithEmailAndPassword, onAuthStateChanged,signOut,sendPasswordResetEmail } from "firebase/auth";
import {app} from '@/assets/css/f/i/r/config';
import { getStorage, getDownloadURL, ref as sRef,  uploadBytesResumable} from "firebase/storage";



const delay = ms => new Promise(res => setTimeout(res, ms));

function logDbError(action, path, error) {
    console.warn(`[Firebase] ${action} failed at "${path}":`, error?.message || error);
}



 class Firebase{
    constructor(){
        this.storage = getStorage();
        this.db = getDatabase();
        this.analytics = getAnalytics(app);
        this.auth = getAuth();
    }

    // async paginate(group = 3, data, page){
    //     const paginatde_data = [];
    //     for(let i = 0;i<data.length;i++){
    //         let obj = data[i];
    //         obj['no'] = i+1;
    //         paginatde_data.push(obj);
    //     } 
    //     const length = data?.length;
    //     const totalpages = length/group;





    // }
    async auth_user(){
        return await new Promise((resolve)=>{
            onAuthStateChanged(this.auth,(user)=>{
                resolve(user);
            })
        });
    }

    async signOut(){
        return await new Promise((resolve)=>{
            signOut(this.auth).then(()=>{
                resolve(true);
            }).catch(async (error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.signOut();
                }else{
                    resolve(error.message);
                   
                }
            })
        })
    }
        
    async signup(data){
        return await new Promise((resolve)=>{
          createUserWithEmailAndPassword(this.auth, data.email, data.password).then((userCredential)=>{
            const user = userCredential.user;
          data.password = null;
          data.uid = user['uid'];
            set(ref(this.db, "userAccount/"+user.uid), data).then(()=>{
                    resolve({stat:true, value:data, uid:user.uid});
            }).catch(async (error)=>{
                
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.signup(data);
                }else{
                    resolve({stat:false, message:error.message});
                }
            })

          }).catch(async (error)=>{
            if(error.message === 'Error: Client is offline.'){
                await delay(2000);
                   this.signup(data);
            }else{
                resolve({stat:false, message:error.message});
               
                
            }
        });

        }
    )}

 
    async signin(email, password){
        return await new Promise((resolve)=>{
        signInWithEmailAndPassword(this.auth, email, password).then((userCredential)=>{
                let user = userCredential.user;
               
                resolve({value:user, stat:true});
        }).catch(async(error)=>{
            if(error.message === 'Error: Client is offline.'){
                await delay(2000);
                   this.signin(email, password);
            }else{
                resolve({value:error.message, stat:false});
               
            }
        })
    })

    }

    
    async resetPassword(email) {
        return await new Promise((resolve)=>{
        sendPasswordResetEmail(this.auth, email).then(()=>{
            resolve({ stat: true })
        }).catch(async(error)=>{
            if(error.message === 'Error: Client is offline.'){
                await delay(2000);
                   this.resetPassword(email);
            }else{
                resolve({ stat: false, value: error.message });
            }
        })
    })

    }

    watchAuth(callback) {
        return onAuthStateChanged(this.auth, callback)
    }
    async insert(path = typeof String, data = typeof Object){
       
        return await new Promise((resolve)=>{
            set(ref(this.db, path), data).then(()=>{
                    resolve(true);
            }).catch(async(error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.insert(path, data);
                }else{
                    logDbError('insert', path, error);
                    resolve(false);
                }
            })
      

        })
    }
    async update_value(path  = typeof String, data = typeof Object){
        return await new Promise((resolve)=>{
            update(ref(this.db, path), data).then(()=>{
                resolve(true);
            }).catch(async(error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.update(path, data);
                }else{
                    logDbError('update', path, error);
                    resolve(false);
                }
            })
        })

    }
    async delete(path){
        return await new Promise((resolve)=>{
            remove(ref(this.db, path)).then(()=>{   
                resolve(true);
            }).catch(async(error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.delete(path);
                }else{
                    logDbError('delete', path, error);
                    resolve(false);
                }
            })
        })

    }
    async getValue(path){
        return await new Promise((resolve)=>{
            get(child(ref(this.db), path)).then((snapshot)=>{
                if(snapshot.exists()){
                    resolve(snapshot.val());
                }else{
                    resolve(null);
                }
            }).catch(async(error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.getValue(path);
                }else{
                    logDbError('read', path, error);
                    resolve(null);
                }
            })

        })
    }
    async getImage(path, name, ext){
        return await new Promise((resolve)=>{
        getDownloadURL(sRef(this.storage, path+'/'+name+'.'+ext))
        .then((url) => {
        
          const xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
       
          xhr.open('GET', url);
          xhr.send();
          resolve(url);
        })
        .catch(async(error) => {
            if(error.message === 'Error: Client is offline.'){
                await delay(2000);
                   this.getImage(path, name, ext);
            }else{
                
                resolve(false);
            }
        })
    })
    }

    async getObjects(path){
        return await new Promise((resolve)=>{
            get(child(ref(this.db), path)).then((snapshot)=>{
                if(snapshot.exists()){
                    let result = [];
                    snapshot.forEach(childSnapshot =>{
                        result.push(childSnapshot.val());
                    });
                    resolve(result);
                }else{
                    resolve(null);
                }
            }).catch(async(error)=>{
                if(error.message === 'Error: Client is offline.'){
                    await delay(2000);
                       this.getObjects(path);
                }else{
                    logDbError('read', path, error);
                    resolve(null);
                }
            })
        })

    }
  
    async setImage(image , name){
    
        return await new Promise((resolve)=>{
            const metaData = {
                contentType: image.type,
                
            }
           
            const storageRef = sRef(this.storage, 'users/'+name+'.png');
            const uploadTask = uploadBytesResumable(storageRef,image,metaData);
                uploadTask.on('state-changed', ()=>{
              
            },(error)=>{
                logDbError('upload', name, error);
               resolve(false);
            },async ()=>{
             await   getDownloadURL(uploadTask.snapshot.ref).then((downloadURL)=>{
                   resolve(downloadURL);
                
                })
            })
                
    
        
        })
    }
    async trackPageVisit(page, path, meta = {}) {
        const date = new Date().toISOString().slice(0, 10)

        try {
            await update(ref(this.db), {
                'analytics/total': increment(1),
                [`analytics/pages/${page}`]: increment(1),
                [`analytics/daily/${date}`]: increment(1),
            })

            await push(ref(this.db, 'analytics/recent'), {
                page,
                path,
                at: Date.now(),
                referrer: meta.referrer || '',
            })
        } catch (error) {
            logDbError('trackPageVisit', `analytics/${page}`, error)
        }

        try {
            if (this.analytics) {
                logEvent(this.analytics, 'page_view', {
                    page_title: page,
                    page_path: path,
                })
            }
        } catch (error) {
            console.warn('[Firebase] analytics event failed:', error?.message || error)
        }
    }

    async getUserInfo(uid){
        return new Promise((resolve)=>{
            const temp_object = async (path) =>{
                return await this.getObjects(path);
            }
            
            async function searchUsers() {
                let users = await temp_object('userAccount');
                for(let user of users){
                    if(user.uid === uid){
                        resolve(user);
                        break;
                    }
                }
            }
            searchUsers();
        });
    }




}

const firebase = new Firebase()

export { Firebase, firebase }